import React from 'react';
import { useFormContext } from 'react-hook-form';
import ProviderSelector from '@/pages/Restaurant/OperationZones/ProviderSelector/ProviderSelector';
import type { Territory } from '@/pages/Restaurant/OperationZones/OperationZones.type';
import { StepWrapper } from '../CreateRestaurantForm.style';

interface OperationZoneProviderStepProps {
    territories: Territory[];
}

const OperationZoneProviderStep: React.FC<OperationZoneProviderStepProps> = ({ territories }) => {
    const { setValue, watch } = useFormContext();
    const selectedCode = watch('operationZoneCode');
    const selectedProvider: string | null = watch('operationZoneProvider') ?? null;

    const territory = territories.find((t) => t.code === selectedCode);
    const availableProviders = territory?.availableProviders ?? [];

    const handleChange = (provider: string) => {
        setValue('operationZoneProvider', provider, { shouldValidate: true });
    };

    return (
        <StepWrapper>
            <ProviderSelector
                availableProviders={availableProviders}
                value={selectedProvider}
                onChange={handleChange}
            />
        </StepWrapper>
    );
};

export default OperationZoneProviderStep;
